<template>
  <sidebar :options="config"
           :fold-state="isFold"
           permission="master">

    <sidebar-profile slot="header"/>

  </sidebar>
</template>

<script>
import Sidebar from '@/modules/sidebar/Sidebar';
import SidebarConfig from '@/configs/sidebar';
import SidebarProfile from '@/spa/components/sidebar/profile/SidebarProfile';

export default {
  name: 'SidebarWrapper',
  components: {
    Sidebar,
    SidebarProfile,
  },
  data() {
    return {
      config: SidebarConfig(),
    };
  },
  computed: {
    isFold() {
      return this.$store.getters.isFold;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/spa/components/sidebar/SidebarWrapper.vue